<template>
	<div class="content">
		<header>
			<div class="header-photo" title="点击更新大头照" @click="openPhotoSetting">
				<van-image width="100%" :src="photo" />
			</div>
			<div class="header-info">
				<span>李星泽</span>
				<span class="year-old">已经出生{{ year }}辣</span>
			</div>
		</header>
		<div class="menu-list">
			<div class="menu-item" v-for="(menu, index) in menuList" :key="index"
				@click="menuEvent(menu.url, menu.displayDialog)">
				<span class="q-emoji-wrap" aria-hidden="true">
					<span class="q-emoji">{{ menu.emoji }}</span>
				</span>
				<span>{{ menu.text }}</span>
			</div>
			<div class="menu-item">
				<span class="q-emoji-wrap" aria-hidden="true">
					<span class="q-emoji">🎭</span>
				</span>
				<span>{{ displayRole }}</span>
			</div>
			<div class="menu-item" @click="logout">
				<span class="q-emoji-wrap" aria-hidden="true">
					<span class="q-emoji">🚪</span>
				</span>
				<span>退出登录</span>
			</div>
			<van-dialog class="volume-setting-dialog" v-model="showVolumeSetting" title="设置奶量" showCancelButton
				@confirm="settingVolume">
				<div v-for="(_, index) in volumeSettings" :key="index">
					<van-field v-model="volumeSettings[index]" placeholder="请输入奶量" /><van-icon
						@click="removeOption(index)" name="minus" />
				</div>
				<van-button plain type="primary" @click="addOption">添加选项</van-button>
			</van-dialog>
			<van-dialog v-model="showPhotoSetting" title="更新大头照" showCancelButton @confirm="settingPhoto">
				<van-uploader v-model="fileList" :after-read="afterRead" :max-count="1" />
			</van-dialog>
		</div>

	</div>

</template>

<script>
import {
	updateUserPreference,
	getUserPreference,
	uploadFile
} from '../util/api'
import { Notify } from 'vant';
export default {
	name: 'OtherCom',
	data() {
		return {
			showVolumeSetting: false,
			showPhotoSetting: false,
			volumeSettings: [],
			year: null,
			fileList: [],
			photo: null,
			menuList: [
				{
					url: 'statistics',
					text: '干饭数据查询',
					emoji: '📊'
				},
				{
					url: 'foodMenu',
					text: '菜谱',
					emoji: '🍱'
				},
				{
					url: 'recipes',
					text: '今天吃啥',
					emoji: '📅'
				},
				{
					url: 'english',
					text: '英语',
					emoji: '📖'
				},
				{
					url: 'miaotixing',
					text: '喵提醒设置',
					emoji: '⏰'
				},
				{
					url: 'baking',
					text: '烘培',
					emoji: '🧁'
				},
				{
					url: 'sport',
					text: '记录运动',
					emoji: '🏃'
				},
				{
					url: 'loseWeight',
					text: '减肥大计',
					emoji: '⚖️'
				},
				{
					text: '设置奶量',
					emoji: '🍼',
					displayDialog: 'showVolumeSetting'
				},
			]
		}
	},
	computed: {
		displayRole() {
			const name = this.$store.state.user?.display_name
			return name ? `当前角色(${name})` : '当前角色'
		}
	},
	methods: {
		menuEvent(url, displayDialog) {
			if (url) {
				this.toPage(url)
			} else {
				this[displayDialog] = true
			}
		},
		openPhotoSetting() {
			this.fileList = this.photo ? [{ url: this.photo, isImage: true }] : []
			this.showPhotoSetting = true
		},
		afterRead(file) {
			file.status = 'uploading';
			file.message = '上传中...';
			const formData = new FormData();
			formData.append('file', file.file);
			uploadFile(formData).then((res) => {
				if (res?.data?.success) {
					file.status = 'done';
					file.message = '上传成功';
					file.url = `https://api.starl.site${res.data.filePath}`
					this.photo = file.url
				} else {
					file.status = 'failed';
					file.message = '上传失败';
				}
			})
		},
		calculateTimeDifference(startDateString) {
			// 将输入的日期字符串转换为 Date 对象
			const startDate = new Date(startDateString);
			const currentDate = new Date();

			// 确保输入的日期合法
			if (isNaN(startDate)) {
				return "无效的日期格式";
			}

			// 初始化年、月、日差值
			let years = currentDate.getFullYear() - startDate.getFullYear();
			let months = currentDate.getMonth() - startDate.getMonth();
			let days = currentDate.getDate() - startDate.getDate();

			// 处理负数的情况
			if (days < 0) {
				// 获取上一个月的最后一天日期
				const previousMonth = new Date(
					currentDate.getFullYear(),
					currentDate.getMonth(),
					0
				);
				days += previousMonth.getDate();
				months -= 1;
			}

			if (months < 0) {
				months += 12;
				years -= 1;
			}

			return `${years}年${months}个月${days}天`;
		},
		toPage(newPage) {
			this.$router.push(`/${newPage}`)
		},
		settingVolume() {
			updateUserPreference({
				eatenVolume: JSON.stringify(this.volumeSettings)
			}).then(() => {
				Notify({ type: 'success', message: '保存成功' });
			})
		},
		logout() {
			this.$store.commit('clearAuth')
			this.$router.replace('/login')
		},
		settingPhoto() {
			if (!this.photo) {
				Notify({ type: 'error', message: '请选择照片' });
				return
			}
			updateUserPreference({
				photo: this.photo
			}).then(() => {
				Notify({ type: 'success', message: '保存成功' });
			})
		},
		addOption() {
			this.volumeSettings.push(null)
		},
		removeOption(index) {
			this.volumeSettings = this.volumeSettings.filter((_, i) => index !== i)
		},
		getUserPreference() {
			getUserPreference().then((data) => {
				this.volumeSettings = JSON.parse(data.data[0].eatenVolume)
				this.photo = data.data[0].photo
			})
		},
	},
	mounted() {
		this.getUserPreference();
		this.year = this.calculateTimeDifference('2024-06-24');
		const role = this.$store.state.user?.display_name
		if (['爸爸', '妈妈'].includes(role)) {
			this.menuList.push({
				url: 'charge',
				text: '记账',
				emoji: '🧾'
			}, {
				url: 'accountVault',
				text: '账号密码',
				emoji: '🔐'
			},)
		}
		if (role === '爸爸') {
			this.menuList.push({
				url: 'deviceKey',
				text: '设备密钥',
				emoji: '🔑'
			})
		}
	}
}
</script>


<style scoped>
.content {
	/* Q版：和 foodMenu 统一的软萌底色 */
	--q-bg0: #fff7fb;
	--q-bg1: #f2fbff;
	--q-card: rgba(255, 255, 255, 0.92);
	--q-line: rgba(15, 23, 42, 0.08);
	--q-shadow: 0 10px 24px rgba(17, 24, 39, 0.08);
	--q-shadow-sm: 0 6px 14px rgba(17, 24, 39, 0.08);
	--q-radius: 16px;

	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	height: 100%;
	min-height: 0;
	overflow: hidden;
	padding: 14px;
	box-sizing: border-box;
	position: relative;
	font-family: "Comic Sans MS", "Microsoft YaHei UI", "PingFang SC", "Hiragino Sans GB", system-ui, -apple-system,
		BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
	background: radial-gradient(120% 90% at 20% 0%, var(--q-bg0) 0%, transparent 60%),
		radial-gradient(120% 90% at 90% 30%, var(--q-bg1) 0%, transparent 55%),
		#ffffff;
}

.content::before,
.content::after {
	content: "";
	position: fixed;
	z-index: -1;
	pointer-events: none;
	opacity: 0.9;
}
.content::before {
	width: 240px;
	height: 240px;
	left: -90px;
	top: 120px;
	background: radial-gradient(circle at 30% 30%, rgba(255, 184, 220, 0.55), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(110, 231, 255, 0.45), transparent 62%);
	border-radius: 999px;
}
.content::after {
	width: 280px;
	height: 280px;
	right: -140px;
	bottom: 80px;
	background: radial-gradient(circle at 40% 30%, rgba(196, 255, 214, 0.5), transparent 60%),
		radial-gradient(circle at 70% 70%, rgba(255, 224, 170, 0.45), transparent 62%);
	border-radius: 999px;
}
/* 不要对 `.content > *` 统一加 position/z-index，会破坏 Vant Dialog/Popup 的 fixed 布局 */

header {
	display: flex;
	justify-content: space-around;
	margin: 0;
	flex-shrink: 0;
	background: var(--q-card);
	border: 2px solid transparent;
	border-radius: 20px;
	padding: 14px;
	box-shadow: var(--q-shadow);
	background:
		linear-gradient(var(--q-card), var(--q-card)) padding-box,
		linear-gradient(135deg, rgba(52, 195, 255, 0.45), rgba(255, 107, 132, 0.35), rgba(45, 212, 191, 0.35)) border-box;
	position: relative;
	overflow: visible;
}

.content header::after {
	content: "🐲";
	position: absolute;
	right: 12px;
	top: 10px;
	font-size: 18px;
	opacity: 0.85;
	transform: rotate(10deg);
	pointer-events: none;
}

.header-photo {
	width: 80px;
	display: flex;
	justify-content: center;
	border-radius: 16px;
	overflow: hidden;
	border: 2px solid rgba(255, 255, 255, 0.9);
	box-shadow: 0 10px 18px rgba(17, 24, 39, 0.12);
	cursor: pointer;
}

.header-photo:active {
	transform: scale(0.98);
}

.header-info {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	flex: 1;
	text-align: center;
	gap: 2px;
}

.header-info span {
	font-size: 18px;
	font-weight: bold;
}

.header-info .year-old {
	font-weight: normal;
	font-size: 12px;
	color: rgba(107, 114, 128, 0.95);
	background: rgba(52, 195, 255, 0.12);
	border: 1px solid rgba(52, 195, 255, 0.18);
	padding: 2px 10px;
	border-radius: 999px;
}

.menu-list {
	padding: 14px 0 8px;
	display: flex;
	box-sizing: border-box;
	gap: 12px;
	flex-wrap: wrap;
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	-webkit-overflow-scrolling: touch;
	align-content: flex-start;
}

.menu-item {
	border: 1px solid var(--q-line);
	padding: 16px 8px 14px;
	width: 120px;
	text-align: center;
	box-sizing: border-box;
	flex-basis: calc((100% - 24px) / 3);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 10px;
	background: rgba(255, 255, 255, 0.88);
	border-radius: 18px;
	box-shadow: var(--q-shadow-sm);
	transition: transform 140ms ease, box-shadow 140ms ease, filter 140ms ease;
	user-select: none;
	position: relative;
	overflow: visible;
}

.menu-item::before {
	content: "";
	position: absolute;
	inset: -1px;
	border-radius: 18px;
	background: linear-gradient(180deg, rgba(52, 195, 255, 0.10), rgba(255, 107, 132, 0.08));
	opacity: 0.9;
	pointer-events: none;
	z-index: 0;
}

.menu-item > * {
	position: relative;
	z-index: 1;
}

.menu-item:active {
	transform: translateY(1px) scale(0.985);
	box-shadow: 0 4px 10px rgba(17, 24, 39, 0.08);
	filter: saturate(1.05);
}

.menu-item /deep/ img,
.menu-item /deep/ .van-image__img {
	border-radius: 12px;
}

.q-emoji-wrap {
	width: 46px;
	height: 46px;
	border-radius: 16px;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: radial-gradient(circle at 30% 30%, rgba(110, 231, 255, 0.30), rgba(52, 195, 255, 0.10) 60%),
		linear-gradient(180deg, rgba(255, 255, 255, 0.78), rgba(255, 255, 255, 0.55));
	border: 1px solid rgba(52, 195, 255, 0.18);
	box-shadow: 0 10px 18px rgba(52, 195, 255, 0.16);
}

.q-emoji {
	font-size: 24px;
	line-height: 1;
	transform: translateY(1px);
	filter: saturate(1.06);
}

.menu-item span {
	font-size: 13px;
	font-weight: 700;
	letter-spacing: 0.2px;
	color: rgba(47, 52, 64, 0.96);
}

.content /deep/ .van-dialog__content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
	padding: 24px 0;
}

.content /deep/ .van-dialog {
	border-radius: 18px;
	overflow: hidden;
}

/* Q版弹框：让“设置奶量/设置角色”更像贴纸卡 */
.content /deep/ .van-dialog__header {
	font-weight: 800;
	letter-spacing: 0.2px;
}
.content /deep/ .van-dialog__footer {
	background: rgba(255, 255, 255, 0.9);
}
.content /deep/ .van-dialog__confirm {
	border: none;
	background: linear-gradient(180deg, rgba(52, 195, 255, 1) 0%, rgba(110, 231, 255, 1) 100%);
	color: #fff;
	font-weight: 800;
}
.content /deep/ .van-dialog__cancel {
	color: rgba(47, 52, 64, 0.9);
	font-weight: 700;
}

.volume-setting-dialog /deep/ .van-field {
	border-radius: 12px;
	background: rgba(255, 255, 255, 0.92);
	box-shadow: 0 6px 14px rgba(17, 24, 39, 0.06);
	margin-bottom: 6px;
}
.volume-setting-dialog /deep/ .van-icon-minus {
	color: rgba(255, 95, 122, 0.95);
}

/* 设置奶量：把“添加选项”做成更Q的主按钮 */
.volume-setting-dialog /deep/ .van-button {
	border-radius: 999px;
	font-weight: 800;
}
.volume-setting-dialog /deep/ .van-button--plain.van-button--primary {
	border: none;
	color: #fff;
	background: linear-gradient(180deg, rgba(52, 195, 255, 1) 0%, rgba(110, 231, 255, 1) 100%);
	box-shadow: 0 10px 20px rgba(52, 195, 255, 0.22);
	width: calc(100% - 32px);
	margin: 6px 16px 0;
}

.content /deep/ .van-dialog__content>div {
	display: flex;
	align-items: center;
	justify-content: center;
	border-bottom: 1px solid #ececec;
	width: 78px;
	padding: 0 8px;
}

.content /deep/ .van-dialog__content>div input {
	text-align: center;
}
</style>
